export const Routes = {
  agent: {
    path: "/agents",
  },
  billing: {
    path: "/billing",
  },
  payments: {
    path: "/payments",
  },
  cards: {
    path: "/cards",
  },
  claims: {
    path: "/claims",
  },
  claimsfaq: {
    path: "https://mutualofenumclaw.com/our-claims/claims-faq",
  },
  claimsContactAdjuster: {
    path: "/claims/contact-adjuster",
  },
  claimsNew: {
    path: "/new-claim",
  },
  documents: {
    path: "/documents",
  },
  faqs: {
    fragments: {
      cards: "cards",
      paperless: "paperless",
    },
    path: "/faqs",
  },
  home: {
    path: "/home",
  },
  login: {
    path: "/login",
  },
  logout: {
    path: "/logout",
  },
  messages: {
    path: "/messages",
  },
  paperless: {
    path: "/paperless",
  },
  paperlessBilling: {
    path: "/paperless/billing",
  },
  paperlessPolicy: {
    path: "/paperless/policy",
  },
  policies: {
    path: "/policies",
  },
  profile: {
    path: "/profile",
  },
  reauth: {
    path: "/reauth",
  },
  register: {
    path: "/register",
  },
  registerConfirm: {
    path: "/register/confirm",
  },
  registerSetup: {
    path: "/register/setup",
  },
  registerVerify: {
    path: "/register/verify",
  },
  registerVerifyCommercial: {
    path: "/register/verify-commercial",
  },
  resetPassword: {
    path: "/help/password",
  },
  resetPasswordChange: {
    path: "/help/password/reset",
  },
  resetPasswordConfirm: {
    path: "/help/password/confirm",
  },
};
